import React, { useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import success from '../../../images/success icon.png';
import consultation from '../../../images/consultation.png';
import calender from '../../../images/calender.png';
import time from '../../../images/time.png';
import pateint1 from '../../../images/patient1.png';

const Completed = () => {
  const [height, setHeight] = useState(0);
  return (
    <div>
      <Header setHeight={setHeight} />
      <div
        className="profile_crumb"
        style={{ height: height + 10 + "px" }}
      ></div>
      <div className="profile_page pb-5">
        <section className="py-5">
          <div className="container mt-5">
            <div className="w-70 w-lg-90 bg-white shadow rounded_outer py-5 mx-auto">
              <div className="pb-3 px-5 pt-3">
                <div className="appointmentHead d-flex flex-column justify-content-center mx-auto align-items-center pb-4">
                  <img src={success} alt="success icon" />
                  <h2 className="h2heading font-weight-bold py-4 text-center" style={{ letterSpacing: "1px", color: "#25BCA7" }}>Appointment Confirmed</h2>
                  <span>Your appointment ID is <b>123456789</b></span>
                  <span >We have sent you an SMS with details.</span>
                </div>
                <hr />

                <div className="row py-4">
                  <div className="col-lg-3 col-xl-3"></div>
                  <div className="col-lg-6 col-xl-6 col-md-12">
                    <div className="appointmentBody1 w-100 d-flex align-items-center">
                      <img className="mr-4" src={consultation} alt="icon" />
                      <div className="appointmentSubBody1">
                        <span className="h4heading font-weight-bold" style={{ padding: "0" }}>In-Clinic Appointment</span><br />
                        <span className="my-2 h3desc align-middle">
                          <span className="mr-5 font-weight-normal"> <img src={calender} alt="calender icon" /> Nov 30, 2020 </span>
                          <span className="font-weight-normal"> <img src={time} alt="calender icon" /> At 01:00AM </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-xl-3"></div>
                </div>

                <div className="row py-3">
                  <div className="col-lg-3 col-xl-3"></div>
                  <div className="col-lg-6 col-xl-6 col-md-12">
                  <div className="appointmentBody2 w-100 d-flex align-items-center">
                    <img className="mr-3" src={pateint1} alt="icon" />
                    <div className="appointmentSubBody2">
                      <span className="h4heading font-weight-bold" > Patient Details</span>
                      <span className="my-2 d-flex align-items-center h3desc">
                        <span className="mr-5 d-flex flex-column "> <span>Patient Name</span> <span className="font-weight-bold">John Doe</span></span>
                        <span className=" d-flex flex-column "> <span>Mobile Number</span> <span className="font-weight-bold">+808 123 4275</span></span>
                      </span>
                    </div>
                  </div>
                  </div>
                  <div className="col-lg-3 col-xl-3"></div>
                </div>


              <hr/>
                <div className="row py-4">
                  <div className="w-100 d-flex justify-content-center align-items-center appointmentButtons">
                    <button className="appointmentButton tableButton mr-4">CANCEL APPOINTMENT</button>
                    <button className="appointmentButton tableButton" >RESCHEDULE APPOINTMENT</button>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Completed;
